import { FilterToolbarGroup } from 'src/components/Filters';
import { ContentId } from 'src/utils/constants/contentId';
import { ActionOutboxEntityType } from 'src/WebApiController';

import { useTagFiltersBase } from './useTagFiltersBase';

export type EventTagInfoFilter = {
  eventTagName: string | null;
  eventTagValue: string | null;
  eventTagValues?: string[] | null;
  eventTagOperation?: string | null;
};

export const useEventTagFilters = <TFilter extends EventTagInfoFilter>(
  query: TFilter,
  setQuery: (query: TFilter) => void,
  isMultiValue: boolean,
  disabled?: boolean
): FilterToolbarGroup => {
  return useTagFiltersBase(
    query.eventTagName,
    query.eventTagValue,
    query.eventTagValues ?? null,
    query.eventTagOperation ?? null,
    (eventTagName) =>
      setQuery({
        ...query,
        eventTagName,
        eventTagValue: null,
        eventTagValues: [],
        eventTagOperation: null,
      }),
    (eventTagValue) => setQuery({ ...query, eventTagValue }),
    (eventTagValues) => setQuery({ ...query, eventTagValues }),
    (eventTagOperation) => setQuery({ ...query, eventTagOperation }),
    ContentId.EventTag,
    ActionOutboxEntityType.SellerEvent,
    isMultiValue,
    undefined,
    disabled,
    'eventTagName',
    'eventTagValue'
  );
};
